import { VoterModal } from "../features/dashboard/components/VoterModal";
import { FriendProfileModal } from "../features/friends/FriendProfileModal";

/**
 * Renders VoterModal + FriendProfileModal from the props returned by useProfileInteraction().
 *
 * Usage:
 *   const { handleAvatarClick, modalProps } = useProfileInteraction();
 *   <ProfileInteractionModals {...modalProps} />
 */
export function ProfileInteractionModals({
  voterModalOpen,
  setVoterModalOpen,
  voterModalUsers,
  profileUser,
  profileModalOpen,
  setProfileModalOpen,
  handleViewProfile,
  anonymous = false,
}) {
  return (
    <>
      <VoterModal
        open={voterModalOpen}
        onOpenChange={setVoterModalOpen}
        users={voterModalUsers}
        anonymous={anonymous}
        onViewProfile={handleViewProfile}
      />
      <FriendProfileModal
        open={profileModalOpen}
        onOpenChange={setProfileModalOpen}
        user={profileUser}
        onFriendClick={handleViewProfile}
      />
    </>
  );
}
